const UPDATED_AT_FORMAT = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  timeZone: 'UTC',
});

export function formatUpdatedAt(
  updatedAt: string | undefined
): string | undefined {
  if (!updatedAt) {
    return undefined;
  }

  const date = new Date(updatedAt);

  return Number.isNaN(date.getTime())
    ? undefined
    : UPDATED_AT_FORMAT.format(date);
}
